import {
    OnboardingTutorialMainWrapperContainerStyled,
    OnboardingTutorialMainWrapperStyled
} from "./styled/OnboardingTutorialMainWrapperStyled";
import {updateUrlWithLocale} from "../../onboardingTutorialUtils";
import {ONBOARDING_IMAGES_FOLDER} from "../../../onboardingConstants";
import { useLangContext } from "../../../../../providers/LangProvider/LangProviderContext.js";

function OnboardingTutorialMainWrapper(props) {
    const {locale} = useLangContext();
    const {backgroundImg, children, contentContainerMaxWidth = '248px'} = props;
    return <div className="d-flex justify-content-center align-items-center h-100">
        <OnboardingTutorialMainWrapperStyled
                background={updateUrlWithLocale(`${ONBOARDING_IMAGES_FOLDER}/${backgroundImg}`, locale)}>
            <OnboardingTutorialMainWrapperContainerStyled contentContainerMaxWidth={contentContainerMaxWidth}>
                {children}
            </OnboardingTutorialMainWrapperContainerStyled>
        </OnboardingTutorialMainWrapperStyled>
    </div>
}

export default OnboardingTutorialMainWrapper;
